import { cloneDeep } from "base/utils";

import { FORMAT_TO_TAG_MAP, FORMAT_TYPES } from "./constants.js";

export * from "./constants.js";
export {
  deserializer,
  deserializeNode,
  deserializeHTML
} from "./deserializers/index.js";
export { serializer, serializeHTML } from "./serializers/index.js";
export { markdownFromDelta, htmlMarkup } from "./markdown.js";

export function createElement(type = "span") {
  return document.createElement(FORMAT_TO_TAG_MAP[type] || type);
}

export function setAttribute(element, key, value) {
  if (key === "class") {
    element.classList.add(value);
  } else {
    element.setAttribute(key, value);
  }
}

export function createTextNode(text) {
  return document.createTextNode(text);
}

export function isUrl(string) {
  if (typeof string !== "string") {
    return false;
  }
  return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.%]+$/.test(
    string
  );
}

export function isHeaderType(blockType) {
  return [FORMAT_TYPES.H1, FORMAT_TYPES.H2, FORMAT_TYPES.H3].includes(
    blockType
  );
}

export function modifyEditorNodeValues(value) {
  const LINK_REGEX = /(http(s)?):\/\/(www\.)?[\w-]+\.?([-\w@:%+.~#?&/=]*)/g;
  function updateNodes(value, output = [], isParentNodeLink = false) {
    for (let node of value) {
      if (node.type === "text") {
        const matches = node.text.match(LINK_REGEX);
        if (matches && matches.length > 0 && !isParentNodeLink) {
          let str = node.text;
          for (let i = 0; i < matches.length; i++) {
            let match = matches[i];
            var split = str.split(match);
            var beforeLink = split.shift();
            output.push({ type: "text", text: beforeLink });
            output.push({
              type: "link",
              data: {
                href: match,
                text: match
              },
              nodes: [{ type: "text", text: match }]
            });
            if (i === matches.length - 1) {
              output.push({ type: "text", text: split[0] });
            }
            str = split.join(match);
          }
        } else {
          output.push(node);
        }
      } else if (node.nodes) {
        let linkNode = false;
        if (node.type === "link" || isParentNodeLink) {
          linkNode = true;
        }
        let nodes = [];
        updateNodes(node.nodes, nodes, linkNode);
        output.push({
          type: node.type,
          data: node.data,
          nodes
        });
      }
    }
  }
  const valueStr = JSON.stringify(value);
  if (LINK_REGEX.test(valueStr)) {
    let outputEditorValue = [];
    let updatedValue = cloneDeep(value);
    updateNodes(updatedValue, outputEditorValue);
    return outputEditorValue;
  }
  return value;
}

export function getEmbeddedVideoUrl(url) {
  // reference https://regexr.com/3dj5t

  const YOUTUBE_REGEX =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;

  const LOOM_REGEX =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?(?:loom\.com\/share\/)([\w-]+)(\S+)?$/;

  const DAILYMOTION_REGEX =
    /^(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com\/video|dai\.ly)\/([\w-]+)(\S+)?$/;

  const VIMEO_REGEX = /https:\/\/([a-z]*\.)?vimeo.com/;

  if (url.match(YOUTUBE_REGEX)) {
    let matched = YOUTUBE_REGEX.exec(url);
    let videoId = (matched && matched.length > 0 && matched[5]) || "";
    return { url: `https://www.youtube.com/embed/${videoId}?wmode=opaque` };
  } else if (url.match(DAILYMOTION_REGEX)) {
    let videoId = url.split("/").pop();
    return { url: `https://www.dailymotion.com/embed/video/${videoId}` };
  } else if (url.match(VIMEO_REGEX)) {
    let videoId = url.split("/").pop();
    return { url: `https://player.vimeo.com/video/${videoId}` };
  } else if (url.match(LOOM_REGEX)) {
    let matched = LOOM_REGEX.exec(url);
    let videoId = (matched && matched.length > 0 && matched[3]) || "";
    return { url: `https://www.loom.com/embed/${videoId}` };
  }

  return { url, isNormalVideo: true };
}
